import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import axiosInstance from "../../api/axiosInstance";
import "./login.scss"

const Login = () => {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [visiblePassword, setVisiblePassword] = useState(false);
    const [isLogin, setLogin] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        const token = localStorage.getItem("token");
        if (token) {
            navigate("/");
        }
    }, [navigate]);

    const handleLogin = async (e) => {
        e.preventDefault();

        setLogin(true);
        setError("");

        try {
            const response = await axiosInstance.post('auth/login', {
                username,
                password,
            });

            // JWT aus dem Antwortobjekt erhalten
            const { token } = response.data;
            localStorage.setItem("token", token); // JWT im lokalen Speicher speichern

            // Weiterleitung nach erfolgreichem Login (z.B. Dashboard)
            navigate("/");

        } catch (err) {
            setError("Fehler bei der Anmeldung. Bitte versuche es erneut.");
        } finally {
            setLogin(false);
        }
    };

    const togglePasswordVisibility = () => {
        setVisiblePassword((prevVisible) => !prevVisible);
    };

    return (
        <div className="login">
            <Helmet>
                <title>News, Termine und Veranstaltungen in Südtirol | wosgeat</title>
            </Helmet>
            <div className="container">
                <div className="logo">
                    <img src="/assets/logo.png" alt="Logo" />
                </div>
                <div className="content">
                    <div className="left">
                        <h2>Willkommen<br />zurück...</h2>
                        <p>Bitte melde dich mit deinen Zugangsdaten von Weinkeller an, um in den Weinkeller einzutreten.</p>
                        <form onSubmit={handleLogin}>
                            <div className="benutzername">
                                <PersonOutlineOutlinedIcon className="icon" />
                                <input
                                    type="text"
                                    id="username"
                                    placeholder="Benutzername"
                                    autoFocus
                                    value={username}
                                    onChange={(e) => setUsername(e.target.value)}
                                    required
                                />
                            </div>
                            <div className="password">
                                <LockOutlinedIcon className="icon" />
                                <input
                                    type={visiblePassword ? "text" : "password"}
                                    id="password"
                                    placeholder="Passwort"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    required
                                />
                                {visiblePassword ? (
                                    <VisibilityOutlinedIcon className="showPassword" onClick={togglePasswordVisibility} />
                                ) : (
                                    <VisibilityOffOutlinedIcon className="showPassword" onClick={togglePasswordVisibility} />
                                )}
                            </div>
                            {error && <span className="error">{error}</span>}
                            <button type="submit" disabled={isLogin} className="solid">
                                {isLogin ? "Lädt..." : "Einloggen"}
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default Login